export default __webpack_public_path__ + "static/media/stop-iphone.4fb0de37.png";